import { Monitor, Shield } from 'lucide-react';
import React from 'react';

const SecurityCenterContent = ({ scenario, onComplete }) => {
  return (
    <div className="h-full bg-white p-4">
      <h2 className="text-xl font-bold mb-4">Windows Security</h2>
      <div className="grid grid-cols-2 gap-4">
        <div className="p-4 border rounded">
          <Shield size={24} className="text-green-500 mb-2" />
          <h3 className="font-medium">Virus & threat protection</h3>
          <p className="text-sm text-gray-600">Protection for your device against threats.</p>
        </div>
        <div className="p-4 border rounded">
          <Monitor size={24} className="text-blue-500 mb-2" />
          <h3 className="font-medium">Device security</h3>
          <p className="text-sm text-gray-600">Security built into your device.</p>
        </div>
      </div>
    </div>
  );
};

export default SecurityCenterContent;

